@if (isDebug) {
  <div>
    <style>
      #mapInfo {
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 10px;
        box-shadow: 1px 1px 4px 1px lightslategray;
        font-size: 0.7rem;
        line-height: 0.8rem;
        padding: 8px 12px 8px 8px;
        position: absolute;
        right: 370px;
        text-shadow: 1px 1px 1px lightslategray;
        top: 110px;
      }

      #mapInfoLabels {
        display: inline-block;
        margin-right: 8px;
        text-align: end;
        width: 35px;
      }

      #mapInfoValues {
        display: inline-block;
        text-align: start;
        min-width: 115px;
      }
    </style>
    <div
      id="mapInfo"
      [ngStyle]="{ left: isLeft ? '370px' : 'inherit', right: isLeft ? 'inherit' : '370px' }"
      (mouseover)="isLeft = !isLeft"
    >
      <div id="mapInfoLabels">
        North:<br />
        Lat: <br />
        South:
        <br />
        <br />
        East: <br />
        Lng: <br />
        West:
        <br />
        <br />
        Zoom:
        <br />
        <br />
      </div>
      <div id="mapInfoValues">
        {{ north }}<br />
        {{ mouseLat }} <br />
        {{ south }}
        <br />
        <br />
        {{ east }} <br />
        {{ mouseLng }} <br />
        {{ west }}
        <br />
        <br />
        {{ zoom }}
        <br />
        <br />
      </div>
      <div>Layers:</div>
      @for (layer of layers; track $index) {
        <div>
          {{ layer }}
        </div>
      }
    </div>
  </div>
}
